import PropTypes from 'prop-types';
import React from 'react';
import {debounce} from 'ts-debounce';

import PlainSearchInput, {ClearType} from './PlainSearchInput';

export interface SearchInputProps {
  placeholder: string;
  doSearch: (query: string | null) => void;
  query?: string | null;
}

export interface SearchInputState {
  value: string | null;
}

export default class SearchInput extends React.Component<SearchInputProps, SearchInputState> {
  static propTypes = {
    placeholder: PropTypes.string.isRequired,
    doSearch: PropTypes.func.isRequired,
    query: PropTypes.string,
  };

  plainSearchInput = React.createRef<PlainSearchInput>();

  constructor(props: SearchInputProps) {
    super(props);
    this.state = {
      value: props.query ?? null,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: SearchInputProps): void {
    if (nextProps.query == null) {
      // Only force value if user hasn't typed anything.
      this.setState({value: null});
    }
  }

  componentDidUpdate(prevProps: SearchInputProps, prevState: SearchInputState): void {
    if (this.state.value !== prevState.value) {
      if (this.state.value != null) {
        this.doSearchDebounced();
      } else {
        // Immediately clear search if null @state.value
        this.doSearch();
      }
    }
  }

  doSearch(): void {
    this.props.doSearch(this.state.value);
  }

  focus(): void {
    if (this.plainSearchInput.current) {
      this.plainSearchInput.current.focus();
    }
  }

  doSearchDebounced = debounce(() => {
    this.doSearch();
  }, 250);

  render(): JSX.Element {
    return (
      <PlainSearchInput
        className="u-width-full"
        clearType={ClearType.X}
        ref={this.plainSearchInput}
        onChange={(e) => {
          this.setState({value: e.target.value});
        }}
        value={this.state.value ?? ''}
        placeholder={this.props.placeholder}
        onEscape={() => {
          if (this.state.value == null) {
            // If @state.value is already null, setState won't trigger anything, so we call doSearch directly.
            this.doSearch();
          } else {
            this.setState({value: null});
          }
          this.focus();
        }}
      />
    );
  }
}
